import { createAction, props } from '@ngrx/store';

import {
  PaginatedElasticSearchBusinessList,
  PaginatedElasticSearchPublicList,
} from '@offconon/core-api';

export const initElasticSearchBox = createAction('[Elastic Search box] Init');

export const setSearchParams = createAction(
  '[Elastic Search box] Set Search Params',
  props<{ searchJson: any }>(),
);
export const getSearchResults = createAction(
  '[Elastic Search box] Get Search Results',
  props<{ searchJson: any; platform: string; page: number; pageSize: number }>(),
);
export const getPaginatedSearchResults = createAction(
  '[Elastic Search box] Get Paginated Search Results',
  props<{ searchJson: any; platform: string; page: number; pageSize: number }>(),
);
export const getSearchResultsSuccess = createAction(
  '[Elastic Search box] Get Search Results Success',
  props<{ searchResults: PaginatedElasticSearchPublicList }>(),
);
export const getPaginatedSearchResultsSuccess = createAction(
  '[Elastic Search box] Get Paginated Search Results Success',
  props<{ searchResults: PaginatedElasticSearchPublicList }>(),
);
export const getSearchResultsFailure = createAction(
  '[Elastic Search box] Get Search Results Success',
  props<{ error: any }>(),
);
export const getBusinessSearchResultsSuccess = createAction(
  '[Elastic Search box] Get Business Search Results Success',
  props<{ searchBusinessResults: PaginatedElasticSearchBusinessList }>(),
);
export const getPaginatedBusinessSearchResultsSuccess = createAction(
  '[Elastic Search box] Get Paginated Business Search Results Success',
  props<{ searchBusinessResults: PaginatedElasticSearchBusinessList }>(),
);
